'use strict';

/**
 * Creates a flat array of input errors, sanitizes them, and slices the first two and returns as sanitizedErrorCaption
 *
 * hasError is true if there are any errors after sanitization.
 */ const useSanitizeInputErrors = (errorCaption, validationError = "")=>{
    const sanitizedErrorCaption = [
        errorCaption,
        validationError
    ].flat(Infinity).filter(Boolean).filter((err)=>typeof err !== "string" || err.trim() !== "").slice(0, 2);
    const hasError = sanitizedErrorCaption.length > 0;
    return {
        hasError,
        sanitizedErrorCaption
    };
};

exports.useSanitizeInputErrors = useSanitizeInputErrors;
//# sourceMappingURL=useSanitizeInputErrors.cjs.map
